import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {colors, Theme, Typography} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 0,
        flexShrink: 0,
        borderRadius: theme.shape.borderRadius,
        lineHeight: '10px',
        fontSize: '10px',
        height: 20,
        minWidth: 20,
        whiteSpace: 'nowrap',
        padding: theme.spacing(0.5, 1)
    },
    rounded: {
        borderRadius: 10,
        padding: theme.spacing(0.5)
    }
}));

const Label = (props: {
    children?: any,
    className?: string,
    color: string,
    shape?: 'square' | 'rounded',
    style?: any,
    variant?: 'contained' | 'outlined'
}) => {
    const propsWithDefaults = {
        ...{
            className: undefined,
            children: undefined,
            style: {},
            color: colors.grey[600],
            variant: 'contained',
            shape: 'square'
        }, ...props
    };

    const {className, variant, color, shape, children, style, ...rest} = propsWithDefaults;

    const classes = useStyles();

    const rootClassName = clsx(
        {
            [classes.root]: true,
            [classes.rounded]: shape === 'rounded'
        },
        className
    );

    const finalStyle: any = {...style};

    if (variant === 'contained') {
        finalStyle.backgroundColor = color;
        finalStyle.color = '#FFF';
    } else {
        finalStyle.border = `1px solid ${color}`;
        finalStyle.color = color;
    }

    return (
        <Typography
            {...rest}
            className={rootClassName}
            style={finalStyle}
            variant="overline"
        >
            {children}
        </Typography>
    );
};

export default Label;
